import React, { useMemo } from "react";
import { useI18n } from "@core/i18n/i18n";
import { useObservable } from "micro-observables";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { physioMeTabletBreakpoint } from "@ui/style";
import { libraryFilterManager } from "@core/service-container";
import { useExerciseLibrary } from "@ui/pages/program-builder/hooks/use-exercise-library";
import { exerciseManager } from "@core/service-container";

const LABEL_KEY_EXERCISE_COUNT = "exerciseLibrary.exerciseCount";

interface ExerciseLibraryCountsProps {
	mode: "SearchResult" | "PreSelected" | "LibraryAndAdded" | "Library" | "Added";
	className?: string;
}

export const ExerciseLibraryCounts: React.FC<ExerciseLibraryCountsProps> = ({ mode, className }) => {
	const { format } = useI18n();
	const selectedExercisesOnAlternativeSelection = useObservable(libraryFilterManager.exerciseWithAlternativesEditedList);
	const exerciseCount = useObservable(exerciseManager.exerciseTotalCount);
	const { filteredSelectedExercises: filteredPreSelectedExercises, filteredExercises } = useExerciseLibrary();

	const value = useMemo(() => {
		switch (mode) {
			case "SearchResult":
				return format("exerciseLibrary.filteredExerciseCounts", {
					filteredCount:
						filteredPreSelectedExercises.length +
						filteredExercises.length +
						selectedExercisesOnAlternativeSelection.length,
					totalCount: exerciseCount,
				});
			case "LibraryAndAdded":
				return format(LABEL_KEY_EXERCISE_COUNT, {
					count: filteredExercises.length + selectedExercisesOnAlternativeSelection.length,
				});
			case "PreSelected":
				return format(LABEL_KEY_EXERCISE_COUNT, {
					count: filteredPreSelectedExercises.length,
				});
			case "Library":
				return format(LABEL_KEY_EXERCISE_COUNT, {
					count: filteredExercises.length,
				});
			case "Added":
				return format(LABEL_KEY_EXERCISE_COUNT, {
					count: selectedExercisesOnAlternativeSelection.length,
				});
		}
	}, [
		filteredExercises.length,
		filteredPreSelectedExercises.length,
		format,
		mode,
		exerciseCount,
		selectedExercisesOnAlternativeSelection.length,
	]);

	return <Sort className={className}>{value}</Sort>;
};

const Sort = styled.div`
	color: ${colors.grey};
	padding: 0 20px;
	@media ${physioMeTabletBreakpoint} {
		padding: 0;
	}
`;
